import {Component, input, inject, computed} from '@angular/core';
import {TrajetDto} from '../../dto/trajet.dto';
import {TrajetSelectionneService} from '../../../gestion-navette/onglets-gestion-navette/trajets/services/trajet-selectionne.service';
import {StatutTrajetEnum} from '../../../gestion-navette/onglets-gestion-navette/trajets/model/statut-trajet.enum';
import {AdaptateurEcranService} from '../../services/adaptateur-ecran.service';

@Component({
	selector: 'app-carte-trajet',
	templateUrl: './carte-trajet.component.html',
	styleUrl: './carte-trajet.component.scss'
})
export class CarteTrajetComponent {
	// Injections
	private adaptateurEcranService = inject(AdaptateurEcranService);
	private trajetSelectionneService = inject(TrajetSelectionneService);

	// Inputs
	cliqueDesactiveSiTrajetPasse = input<boolean>(false);
	delaiLimiteReservationApresDepart = input<number>(0);
	trajet = input.required<TrajetDto>();

	// Computed
	estAffichageMobile = computed(() => this.adaptateurEcranService.estAffichageMobile());
	statutTrajet = computed(() => !!this.trajet().reservationId ? StatutTrajetEnum.RESERVE : this.trajet().statut);

	constructor() {
	}

	// Computed
	trajetAnnule = computed(() => this.trajet().statut === StatutTrajetEnum.ANNULE);

	/**
	 * Indique si le trajet est passé ou non.
	 */
	trajetPasse = computed(() => {
		const dateDepart = new Date(this.trajet().dateDepart);
		const dateAvecDelai = new Date(dateDepart.getTime() + this.delaiLimiteReservationApresDepart() * 60 * 1000);
		return Date.now() > dateAvecDelai.valueOf();
	});

	trajetSelectionne = computed(() => this.trajetSelectionneService.trajetSelectionne()?.id === this.trajet().id);

	/**
	 * Enregistre le trajet sélectionné dans TrajetSelectionneService.
	 */
	enregistrerTrajetSelectionne(): void {
		if (this.trajetSelectionneService.trajetSelectionne()?.id == this.trajet().id) {
			this.trajetSelectionneService.deselectionnerTrajet();
		}
		else {
			this.trajetSelectionneService.enregistrerTrajetSelectionne(this.trajet());
		}
	}
}
